import decl_countries from "@/data/decl_countries.json"
import countries from "@/data/contries.json"

export class Country {
    private name: string;

    constructor(name: string) {
        this.name = name;
    }

    getDeclName(): string{
        const decl = (decl_countries as {[key:string]:string})[this.name];
        return decl || this.name;
    }

    getName(){
        return this.name;
    }

    getParent(){
        const toCountry = countries.find(country => country.label === this.name);
        if(!toCountry || !toCountry.to_city){
            return null;
        }
        return new Country(countries.find(country => country.to_country === toCountry.to_country && !country.to_city)?.label || "")
    }
}